import { YesNoChoice } from "@gamedev-web/one-gaming-crm";

import { TargetPlatform } from "../models/forms";
import { TargetPlatforms } from "../models/targetPlatforms";

export const xboxPlayAnywhereRequiredPlatforms = [
  TargetPlatforms.xboxSeriesXS,
  TargetPlatforms.windowsStore,
] as const;

export const isXboxPlayAnywhereSelected = (value: string | undefined): boolean =>
  value === YesNoChoice.yes.toString();

export const hasXboxPlayAnywhereRequiredPlatforms = (
  xboxPlayAnywhere: string | undefined,
  targetPlatforms: ReadonlyArray<Partial<TargetPlatform>> | undefined
): boolean =>
  !isXboxPlayAnywhereSelected(xboxPlayAnywhere) ||
  xboxPlayAnywhereRequiredPlatforms.every(
    requiredPlatform =>
      targetPlatforms?.some(
        ({ platform, selected, releaseDate }) =>
          platform === requiredPlatform && selected === true && Boolean(releaseDate?.trim())
      ) === true
  );
